import TrackWrapper from '~/components/common/TrackWrapper';
import ShaqName from '~/icons/ShaqName';
import ShaqNameCrossOut from '~/icons/ShaqNameCrossOut';
import formatEvent from '~/utilities/formatEvent';
import styles from './Hero.module.css';
import {
  optimizedMobileImageUrl,
  optimizedTabletImageUrl,
  optimizedDesktopImageUrl
} from './optimized-images';

const cssVariables = {
  '--hero-bg-mobile-url': `url(${optimizedMobileImageUrl})`,
  '--hero-bg-tablet-url': `url(${optimizedTabletImageUrl})`,
  '--hero-bg-desktop-url': `url(${optimizedDesktopImageUrl})`
} as React.CSSProperties;

export default function Hero() {
  return (
    <TrackWrapper
      element="section"
      event={formatEvent('Hero', {
        action: 'viewed'
      })}
      className="relative h-[407px] w-full overflow-hidden sm:h-[462px] md:h-[516px]"
    >
      <div
        role="img"
        aria-label="Shaqvana Hero Background"
        className={styles.heroBackground}
        style={cssVariables}
      />

      <div
        data-testid="shaqvana-hero-content-container"
        className="flex h-full w-full justify-start pl-24 pt-20 md:px-32 md:pt-36 lg:items-center lg:px-[100px]"
      >
        <div className="flex w-full flex-col">
          <div className="z-10 inline-block h-auto w-[111px] sm:w-[144px] md:w-[183px]">
            <ShaqName className="w-full" />
          </div>
          <div
            data-testid="shaqvana-hero-content"
            className="relative z-10 flex w-full items-center justify-start"
          >
            <div
              data-testid="shaqvana-hero-crossout"
              className="absolute left-[-15px] top-[8px] w-[130px] sm:w-[173px] md:top-[12px] md:w-[215px]"
            >
              <ShaqNameCrossOut
                className="h-auto w-full"
                width="232"
                height="60"
              />
            </div>

            <div
              data-testid="shaqvana-hero-heading"
              className="relative w-[295px] max-w-full sm:w-[420px]"
            >
              <span className="text-text-inverse t-brand-md sm:t-brand-lg md:t-brand-xl">
                We’ll drive you happy
              </span>
            </div>
          </div>
        </div>
      </div>
    </TrackWrapper>
  );
}
